import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { sampleTypes } from "../../../../../../../util/uiconstants";
import { GetCardTypeForBody } from '../../../../../../../util/utils';
import SampleListSize from "./SampleListSize";
import { getSampleListId } from "../../../../../../../actions/SampleList/sampleListActions";
import { useSelector, useDispatch } from "react-redux";
import { useEngagementId } from '../../../../../../../util/customHooks';
import Utility from '../../../../../../../util/utilityfunctions';
import { useSmartEvidenceSourceId, useSmartEvidenceSourceEntityId } from '../../../../../../../util/Ares/customHooks';

export default function SampleListSizeBody(props) {
    const {
        bodyContent,
        headerId,
        sectionId,
        bodyId,
        updateBodyOptions,
        getBodiesBySectionId,
        isSnapshotView,
        ...extraProps
    } = props;
    const formBodyBorder = GetCardTypeForBody(bodyContent);

    const dispatch = useDispatch();
    const engagementId = useEngagementId();
    const documentId = Utility.getDocumentIdFromUrl(window);
    const evidenceSourceId = useSmartEvidenceSourceId(documentId);
    const sourceEntityId = useSmartEvidenceSourceEntityId(documentId);
    const sampleList = useSelector((state) => state.sampleList);

    const [expectedItemCount, setExpectedItemCount] = useState(null);
    const [sampleListId, setSampleListId] = useState(null);
    const [showLoader, setShowLoader] = useState(true);
    const [dataFetched, setDataFetched] = useState(false);

    const fetchData = async () => {
        const queryString = {
            entityId: sourceEntityId,
            entityUIDINT: evidenceSourceId,
            hostDocumentId: documentId,
            sampleTypeId: sampleTypes.controlAttributeTesting
        }

        try {
            await dispatch(getSampleListId(engagementId, queryString));
        } finally {
            setDataFetched(true);
        }
    }

    useEffect(() => {
        if (!engagementId || !sourceEntityId || !evidenceSourceId) {
            setDataFetched(true);
            return;
        }

        fetchData();
    }, [sourceEntityId, evidenceSourceId]);

    useEffect(() => {
        if (sampleList.allIds.length > 0) {
            const currentSampleListId = sampleList.allIds[0];
            setExpectedItemCount(sampleList.byId[currentSampleListId].expectedItemCount);
            setSampleListId(currentSampleListId);
        }
    }, [sampleList]);

    useEffect(() => {
        if (dataFetched) {
            setShowLoader(false);
        }
    }, [dataFetched])

    return (
        <Wrapper className={`SectionBodyWrapper ControlAttributes ${formBodyBorder}`}>
            <SampleListSize
                value={expectedItemCount}
                sampleListId={sampleListId}
                isLoading={showLoader}
                maxLength={4}
                {... props} />
        </Wrapper>
    );
};

const Wrapper = styled.section`
    display: block;
`;